<template>
  <div class="common-back-header __flex __flex-vc __flex-cb">
    <img src="@/assets/images/common/left_icon.png" class="img-logo" alt="" @click="toPrePage()">
  </div>
</template>

<script>
export default {
  name: 'CommonHeader',
  props: {
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    toPrePage () {
      this.$router.go(-1)
    }
  },
}
</script>

<style scoped lang="scss">
.common-back-header {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #fff;
  // box-shadow: 0px 3px 18px 0px rgba(51, 51, 51, 0.25);
  img{
    width: 9px;
    height: 16px;
  }
}
</style>
